<script>
import {updateMontant} from '../../../mixins/updateMontant.js';

export default {
  name: 'ligneAFacturer',
  props:{
    phaseId: String,
    phaseName: String,
    visible: Boolean,
    avancement: Number,
  },
  mixins:[
    updateMontant,
  ],
  data(){
    return {
      
    }
  },
  mounted(){
    
  },
  methods:{
    
  }
}
</script>


<template>
  <div class="ligneAFacturer">
    <span class="nom"> {{phaseName}} </span>
    <span> {{avancement}}% </span>
    <div class="icons">
      <span v-if="!visible" class="material-icons" @click="$emit('toFact', phaseId)">arrow_right</span>
      <span v-else class="material-icons selected" @click="$emit('toFact', phaseId)">forward</span>
    </div>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/main.scss';

.ligneAFacturer{
    display: flex;
    align-items: center;
    @include myFont;
    font-size: 13px;
    color: $black-bolder;
}

.nom{
  flex: 1;
  @include monoline;
}

.icons{
  display: flex;
  align-items: center;
  position: relative;
}

.selected{
  color: $main;
  position: relative;
  left: 5px;
  // border: red solid 1px;
  // padding: 0 0 0 5px;
  // margin: 0 -50 0 5px;

}

</style>
